import { render, staticRenderFns } from "./EnterYourName.vue?vue&type=template&id=58f8c26f&scoped=true&"
import script from "./EnterYourName.vue?vue&type=script&lang=js&"
export * from "./EnterYourName.vue?vue&type=script&lang=js&"
import style0 from "./EnterYourName.vue?vue&type=style&index=0&id=58f8c26f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f8c26f",
  null
  
)

export default component.exports